module.exports = __webpack_public_path__ + "img/1500163476.adf9be02.jpg";